import institutionalLocale from 'modules/institutional/presentation/locale';
import institutionalRoutes from 'modules/institutional/presentation/routes';

const institutionalModule = {
  locale: institutionalLocale,
  routes: institutionalRoutes,
};

export default institutionalModule;
